import { render, staticRenderFns } from "./InputComponent.vue?vue&type=template&id=642c0b97&scoped=true&"
import script from "./InputComponent.vue?vue&type=script&lang=js&"
export * from "./InputComponent.vue?vue&type=script&lang=js&"
import style0 from "./InputComponent.vue?vue&type=style&index=0&id=642c0b97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642c0b97",
  null
  
)

export default component.exports